import { render, staticRenderFns } from "./t-app-user-submenu.vue?vue&type=template&id=c7e44544&"
import script from "./t-app-user-submenu.vue?vue&type=script&lang=js&"
export * from "./t-app-user-submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports